import React, { ReactText } from 'react';
import { Data, DropDownProps } from '../type';
import TimesheetStatusFilter from './TimesheetStatusFilter';
import TimeFormatSelector from './TimeFormatSelector';
import { Divider, FormContainer } from 'elmo-elements';

export type DataProps = {
  handleOnChangeSelect: (e: DropDownProps, name: string) => void;
  handleOnChangeStatus: (e: DropDownProps) => void;
  handleOnChangeTimeFormat: (value: ReactText) => void;
  data: Data;
};

const RotaVsTimesheetViewGroup = ({
  handleOnChangeSelect,
  handleOnChangeStatus,
  handleOnChangeTimeFormat,
  data,
}: DataProps) => {
  return (
    <>
      <Divider />
      <br />
      <h3> View </h3>
      <FormContainer maxColumns={3} className="flex-start-align">
        <TimesheetStatusFilter
          data={data}
          handleOnChangeSelect={handleOnChangeSelect}
          handleOnChangeStatus={handleOnChangeStatus}
        />
        <TimeFormatSelector
          data={data}
          handleOnChangeSelect={handleOnChangeSelect}
          handleOnChangeTimeFormat={handleOnChangeTimeFormat}
          handleOnChangeStatus={handleOnChangeStatus}
        />
      </FormContainer>
    </>
  );
};

export default RotaVsTimesheetViewGroup;
